<template>
  <v-toolbar
    class="fudao-toolbar"
    :class="{'timeup': isNearTimeup}"
    color="info white--text"
    height="48"
    dense
    flat>

    <template v-if="isFudaoTeacher">
      <v-tooltip bottom>
        <v-btn
          @click="$emit('toggleChat')"
          color="white--text"
          slot="activator"
          icon>
          <v-badge
            color="red"
            right
            overlap>
            <span v-if="currentUnreadMessageCount" slot="badge">{{currentUnreadMessageCount}}</span>
            <v-icon>chat</v-icon>
          </v-badge>
        </v-btn>
        <span>聊天</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          @click="emitSessionDialogEvent('TeacherVideo')"
          :disabled="sessionType && sessionType !== 'TeacherVideo'"
          :class="{'sharing': isShareVideo}"
          color="white--text"
          slot="activator"
          icon>
          <v-icon>{{sessionIcon['TeacherVideo']}}</v-icon>
        </v-btn>
        <span v-if="isShareVideo">取消視訊分享</span>
        <span v-else>視訊分享</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          @click="emitSessionDialogEvent('Audio')"
          :disabled="sessionType && sessionType !== 'Audio'"
          :class="{'sharing': isShareAudio}"
          color="white--text"
          slot="activator"
          icon>
          <v-icon>{{sessionIcon['Audio']}}</v-icon>
        </v-btn>
        <span v-if="isShareAudio">取消音訊分享</span>
        <span v-else>音訊分享</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          @click="emitSessionDialogEvent('Whiteboard')"
          :disabled="sessionType && sessionType !== 'Whiteboard'"
          :class="{'sharing': isShareWhiteboard}"
          color="white--text"
          slot="activator"
          icon>
          <v-icon>{{sessionIcon['Whiteboard']}}</v-icon>
        </v-btn>
        <span v-if="isShareWhiteboard">取消白板分享</span>
        <span v-else>白板分享</span>
      </v-tooltip>

      <v-divider
        class="mx-3"
        inset
        vertical/>
    </template>
    <!-- <v-spacer /> -->

    <div class="fudao-info">
      <v-icon v-if="sessionType && isFudaoStudent" color="white" class="mr-4 animate-blink">{{sessionIcon[sessionType]}}</v-icon>
      <span>輔導剩餘時間</span>
      <span class="pl-4" :class="{'animate-blink': isNearTimeup}">
        {{fudaoRemainingTime | remaingTime}}
      </span>
    </div>

    <template v-if="isFudaoTeacher">
      <v-divider
        class="mx-3"
        inset
        vertical/>

      <v-tooltip bottom>
        <v-btn
          @click="$emit('endFudao')"
          color="white--text"
          slot="activator"
          icon>
          <v-icon>cancel_presentation</v-icon>
        </v-btn>
        <span>結束輔導</span>
      </v-tooltip>

      <v-tooltip bottom v-if="canExtendFudao">
        <v-btn
          @click="$emit('extendFudao')"
          color="white--text"
          slot="activator"
          icon>
          <v-icon>restore</v-icon>
        </v-btn>
        <span>延長輔導</span>
      </v-tooltip>

    </template>
  </v-toolbar>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import {FudaoEvent, fudaoAppService} from 'langyan';

export default {
  data() {
    return {
      fudaoTotalTime: 0,
      fudaoTimePassed: 0,
      canExtendFudao: true,
      sessionIcon: {
        'TeacherVideo': 'videocam',
        'Audio': 'perm_phone_msg',
        'Whiteboard': 'screen_share'
      }
    };
  },

  computed: {
    ...mapState('fudao', {
      fudaoId: state => state.fudaoDto.id,
      sessionType: state => state.fudaoSession.SessionType
    }),

    ...mapGetters('fudao', {
      isFudaoTeacher: 'isFudaoTeacher',
      isFudaoStudent: 'isFudaoStudent'
    }),

    ...mapGetters('chat', {
      currentUnreadMessageCount: 'currentUnreadMessageCount'
    }),

    fudaoRemainingTime() {
      return (this.fudaoTotalTime - this.fudaoTimePassed)/1000;
    },

    isNearTimeup() {
      return this.fudaoRemainingTime < 180;
    },

    isShareVideo() {
      return this.sessionType === 'TeacherVideo';
    },

    isShareAudio() {
      return this.sessionType === 'Audio';
    },

    isShareWhiteboard() {
      return this.sessionType === 'Whiteboard';
    }
  },

  watch: {
    fudaoId(value) {
      this.updateFudaoExtendAvailable();
    }
  },

  filters: {
    remaingTime(totalSeconds) {
      let minutes = Math.floor(totalSeconds / 60);
      let seconds = totalSeconds % 60;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      return minutes + ':' + seconds;
    }
  },

  async created() {
    this.fudaoTotalTime = await fudaoAppService.queryFudaoTotalTimeAsync(this.fudaoId);
  },

  mounted() {
    this.$eventBus.$on(FudaoEvent.TeacherTimePassed, this.onFudaoTimePassed);
    this.$eventBus.$on(FudaoEvent.FudaoExtended, this.onFudaoExtended);
  },

  beforeDestroy() {
    this.$eventBus.$off(FudaoEvent.TeacherTimePassed, this.onFudaoTimePassed);
    this.$eventBus.$off(FudaoEvent.FudaoExtended, this.onFudaoExtended);
  },

  methods: {
    onFudaoTimePassed(domainEvent) {
      this.fudaoTimePassed = domainEvent.body;
    },

    async onFudaoExtended() {
      this.fudaoTotalTime = await fudaoAppService.queryFudaoTotalTimeAsync(this.fudaoId);
      this.updateFudaoExtendAvailable();
    },

    updateFudaoExtendAvailable() {
      this.canExtendFudao = this.fudaoId ? fudaoAppService.canExtendFudao(this.fudaoId) : false;
    },

    emitSessionDialogEvent(sessionType) {
      if (this.sessionType) {
        this.$emit('endSession', this.sessionType);
      } else {
        this.$emit('inviteSession', sessionType);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>

.fudao-toolbar {
  position: relative;
  border-bottom: 1px solid $def-border-color;
  border: 0;
}

.fudao-info {
  flex-grow: 1;
  text-align: center;
  overflow: hidden;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sharing {
  animation-name: blink;
  animation-duration: 1s;
  animation-iteration-count: infinite;

  &::after {
    content: " ";
    border: 1px solid red;
    width: 100%;
    height: 2px;
    position: absolute;
    transform: rotate(-45deg);
    opacity: 0;
    transition: 0.2s;
  }

  &:hover::after {
    opacity: 1;
  }
}

.timeup {
  background-color: rgb(255, 82, 82) !important;
}

// .animate-progress-flash::before {
//   content: '';
//   position: absolute;
//   background-image: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 20%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 80%, rgba(255,255,255,0) 100%);
//   top: 0;
//   left: -100%;
//   width: 100%;
//   height: 100%;
//   opacity: 0;
//   animation: progress-flash 1.2s linear infinite;
//   animation-delay: 1s;
// }

// .animate-border-blink::before {
//   content: '';
//   position: absolute;
//   box-shadow: 0px 0px 20px 2px white inset;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   opacity: 0;
//   animation: border-blink 0.5s linear infinite;
// }

// @keyframes progress-flash {
//   0% {
//     opacity: 0;
//   }
//   50% {
//     transform: translateX(100%);
//     opacity: 1;
//   }
//   100% {
//     transform: translateX(200%);
//     opacity: 0;
//   }
// }

// @keyframes border-blink {
//   50% {
//     opacity: 1;
//   }
// }
</style>
